import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { AppointmentType } from '../appointment/appointment-type';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class AppointmentTypeService {
  private appointmentTypesUrl = '/api/appointment_types';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  getAll(): Observable<AppointmentType[]> {
    return this.http
      .get<AppointmentType[]>(this.appointmentTypesUrl, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
